/*
 * WW Credits FAQ localization routing
 * Author: Plaud Tayler
 * Version: 1.2.0 - 2026-09-28 17:36 (UTC+8) - Plaud Tayler — route LATAM URLs to complete editable config
 * Page: page.piplcrinto
 */
(function () {
  // Apply URL-selected theme settings to the visible FAQ and schema - Plaud Tayler - 2026-09-28 16:35 - Begin
  function applyFaqLanguage(section) {
    const config = section.querySelector('[data-faq-config]');
    if (!config) return;

    let localizedCopy;
    try {
      localizedCopy = JSON.parse(config.textContent);
    } catch (_error) {
      return;
    }

    const requested = new URLSearchParams(window.location.search).get('lang');
    const requestedLanguage = requested?.toLowerCase();
    const normalized = requestedLanguage === 'jp' ? 'ja' : requestedLanguage === 'es-419' ? 'es-latam' : requestedLanguage;
    const language = Object.keys(localizedCopy).find((code) => code.toLowerCase() === normalized);
    const copy = language && localizedCopy[language];
    if (!copy) return;
    const contentLanguage = language === 'es-latam' ? 'es-419' : language;

    section.querySelectorAll('[data-faq-key]').forEach((item) => {
      const entry = copy.faq?.[item.dataset.faqKey];
      if (!entry?.question || !entry?.answer) {
        item.lang = 'en';
        return;
      }
      const question = item.querySelector('.ww-cf__question span');
      const answer = item.querySelector('.ww-cf__answer');
      if (question) question.textContent = entry.question;
      if (answer) {
        const paragraph = document.createElement('p');
        paragraph.textContent = entry.answer;
        answer.replaceChildren(paragraph);
      }
      item.lang = contentLanguage;
    });

    const fields = {
      heading: copy.heading,
      supportHeading: copy.supportHeading,
      supportText: copy.supportText,
      supportLabel: copy.supportLabel,
      disclaimer: copy.disclaimer
    };
    Object.entries(fields).forEach(([key, value]) => {
      const element = section.querySelector(`[data-i18n-key="${key}"]`);
      if (element && value) {
        element.textContent = value;
        element.lang = contentLanguage;
      }
    });
    section.querySelectorAll('[data-i18n-english-only]').forEach((element) => {
      element.hidden = true;
    });

    const supportLink = section.querySelector('[data-i18n-key="supportLabel"]');
    if (supportLink && copy.supportUrl) supportLink.href = copy.supportUrl;

    const schema = document.querySelector(`script[data-faq-schema="${section.dataset.sectionId}"]`);
    if (schema) {
      const entities = Array.from(section.querySelectorAll('[data-faq-key]')).map((item) => {
        const question = item.querySelector('.ww-cf__question span')?.textContent?.trim();
        const answer = item.querySelector('.ww-cf__answer')?.textContent?.trim();
        if (!question || !answer) return null;
        return { '@type': 'Question', name: question, acceptedAnswer: { '@type': 'Answer', text: answer } };
      }).filter(Boolean);
      schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: entities });
    }
  }

  function applyAllFaqLanguages(root) {
    root.querySelectorAll('.ww-cf[data-section-id]').forEach(applyFaqLanguage);
  }

  applyAllFaqLanguages(document);
  document.addEventListener('shopify:section:load', (event) => applyAllFaqLanguages(event.target));
  // Apply URL-selected theme settings to the visible FAQ and schema - Plaud Tayler - 2026-09-28 16:35 - End
})();
